import _ from 'lodash'
import { PickerType } from '../constants'
import moment from 'moment-mini'

export default {
  name: 'KDatePickerShortcuts',
  inject: ['picker'],
  props: {
    value: {
      type: Array,
      default() {
        return []
      },
    },
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() {
  },
  methods: {
    handleShortcutClick({ value }) {
      if (this.picker.pickerType === PickerType.Date) {
        _.isArray(value) ? this.picker.$emit('pick', _.map(value, item => moment(item))) : this.picker.$emit('pick', moment(value))
      } else if (this.picker.pickerType === PickerType.DateRange) {
        this.picker.$emit('pick', [moment(value[0]).startOf('day'), moment(value[1]).startOf('day')])
      }
    },
  },
  render() {
    if (!this.value || !this.value.length) {
      return
    }

    const css = {
      'km-date-picker__shortcuts': true,
    }

    const data = {
      class: css,
    }

    return (
      <div {...data}>
        {
          _.map(this.value, ({ label, value }) => {
            if (_.isFunction(label)) {
              label = label()
            }

            if (_.isFunction(value)) {
              value = value()
            }

            return (
              <a
                class="km-date-picker__shortcut"
                onClick={() => {
                  this.handleShortcutClick({ label, value })
                }}
              >
                {label}
              </a>
            )
          })
        }
      </div>
    )
  },
}
